import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart, Zap, Shield, Activity, Smile } from 'lucide-react';
export function OutcomesSection() {
  const outcomes = [{
    icon: Zap,
    text: 'Less internal conflict'
  }, {
    icon: Heart,
    text: 'More compassion toward yourself'
  }, {
    icon: Shield,
    text: 'Fewer emotional overreactions'
  }, {
    icon: Activity,
    text: 'A quieter nervous system'
  }, {
    icon: Smile,
    text: 'A deeper sense of wholeness'
  }];
  return <section className="py-24 bg-[#FAF7F2]" data-id="element-156">
      <div className="container mx-auto px-4 md:px-6" data-id="element-157">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-158">
          <FadeIn data-id="element-159">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B4E] mb-6" data-id="element-160">
              What You’ll Notice
            </h2>
            <p className="text-lg text-gray-600" data-id="element-161">
              This book doesn’t demand perfection. It invites honesty. As you
              move through it, you may notice:
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-162">
          {outcomes.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-163">
              <div className="flex flex-col items-center text-center p-6 bg-white rounded-2xl shadow-sm border border-[#E8D5D5] hover:shadow-md transition-shadow h-full" data-id="element-164">
                <div className="w-12 h-12 rounded-full bg-[#FAF7F2] flex items-center justify-center text-[#D4A574] mb-4" data-id="element-165">
                  <item.icon className="w-6 h-6" data-id="element-166" />
                </div>
                <p className="font-medium text-[#2D1B4E]" data-id="element-167">{item.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}